/**
 * Small helpers shared by the tariff_v2 screens. Visual vocabulary follows the
 * v1 tariff screens (HTSCard, IndividualMaterialSummary, DecisionTreeWizard)
 * so users see the same layout and colours.
 */

import { FiAlertTriangle } from 'react-icons/fi';

export const formatHtsCode = (code = '') => {
    const clean = String(code).replace(/\D/g, '');
    return clean.length === 10 ? `${clean.slice(0, 4)}.${clean.slice(4, 6)}.${clean.slice(6)}` : code;
};

/** The schedule's Column 1 General rate as text ("Free", "2.5%", or a specific rate). */
export const rateText = (schedule) => schedule?.general_rate?.raw || 'Not in schedule';

/** Section 232 / 301 lists that list this code; `unknown` when no list file is loaded. */
export function programSummary(programs = []) {
    const listed = programs.filter((p) => p.status === 'applies');
    return {
        unknown: programs.length > 0 && programs.every((p) => p.status === 'unknown'),
        sec232: listed.filter((p) => p.authority === 'section_232'),
        sec301: listed.filter((p) => p.authority === 'section_301'),
    };
}

/** Amber "needs review" banner, styled like the v1 wizard's Important Notes box. */
export function ReviewBanner({ needsReview, reasons = [], openQuestions = [] }) {
    if (!needsReview) return null;
    return (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
                <FiAlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div>
                    <p className="font-medium text-amber-800 mb-1">Needs Review</p>
                    <ul className="text-amber-700 text-sm list-disc pl-4 space-y-0.5">
                        {reasons.map((r, i) => <li key={i}>{r.detail || r.code.replace(/_/g, ' ')}</li>)}
                    </ul>
                    {!!openQuestions.length && (
                        <p className="text-amber-700 text-sm mt-2"><span className="font-medium">Open questions:</span> {openQuestions.join(' · ')}</p>
                    )}
                </div>
            </div>
        </div>
    );
}
